import { Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Layout from '../../components/Layout';
import LoadingBoundary from '../../components/LoadingBoundary';
import { buildMenuResponsive } from '../../helpers/datas';
import { setMenuResponsive } from '../../redux/GlobalRedux';
import { isAuthenticated } from '../../services/Authentification/authentification';
import { useAdherent } from './hooks/useAdherents';
import { useCompte } from './hooks/useCompte';
import { useCompteFidelite } from './hooks/useFidelite';
import { useProgrammes } from './hooks/useProgrammes';
import HomePageContent from './Content';

interface Props {
  classes?: any;
}
const HomePage = (props: Props) => {
  const { classes } = props;
  const { infoCompte, fetchingCompte, errorCompte, fetchingPersonnalistion } = useCompte();
  const { fetchingAdherent, errorAdherent, listeAdherents } = useAdherent(infoCompte);
  const {
    listeAdhesions,
    fetchingProgramme,
    errorProgramme,
    hasServiceFidelisation,
    hasListeProduits,
    hasRemboursement,
    hasRemorquageDepannage,
    hasRenouvellemement,
    hasResiliation,
    infoAssisteur,
    fetchingAssisteur,
    errorAssisteur,
  } = useProgrammes();
  const { fetchingCompteFidelite, errorCompteFidelite, listeCompteFidelite } = useCompteFidelite();

  const authenticated = isAuthenticated();

  const menuResponsive = buildMenuResponsive(
    hasServiceFidelisation,
    hasListeProduits,
    hasRemboursement,
    hasRenouvellemement,
    hasResiliation,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setMenuResponsive(menuResponsive));
  }, [menuResponsive]);

  // getTheme from Layout component
  const [theme, setTheme] = useState<Theme>();

  return (
    <LoadingBoundary
      loading={
        fetchingCompte || fetchingPersonnalistion || fetchingAdherent || fetchingProgramme || fetchingCompteFidelite
      }
      error={errorCompte || errorAdherent || errorProgramme || errorCompteFidelite}
    >
      <Layout authenticated={authenticated} passTheme={setTheme}>
        <HomePageContent
          theme={theme}
          infoCompte={infoCompte}
          listeAdherents={listeAdherents}
          listeCompteFidelite={listeCompteFidelite}
        ></HomePageContent>
      </Layout>{' '}
    </LoadingBoundary>
  );
};

export default HomePage;
